<div class="main_section billing-page">
  <div class="plan_header_section">
    <mat-card class="system-config-card billing-page-card" *ngIf="isAdmin">
      <div class="row setting-row billing-page-header">
        <div class="col s12">
          <h2 class="billing-page-title">Billing</h2>
          <p class="billing-page-subtitle">
            Your plan covers monitoring features (screenshots, live screen, reports). Seats are how many people you can track.
          </p>
        </div>
      </div>

      <div class="setting-section system-config billing-page-body">
        <div class="billing-layout" [class.billing-layout--single]="loading || seatCheckoutExpanded">
        <div class="billing-layout-main">
        <ng-container *ngIf="!loading">
          <!--
            Inline notice replaces the old auto-opened `disableClose: true`
            modal. Users can see every other section (hero, compare plans,
            invoices) while they decide to complete their profile; opening is
            now a deliberate click, not a page-mount side-effect.
          -->
          <div class="billing-profile-banner" *ngIf="needsBillingProfile()">
            <mat-icon class="billing-profile-banner__icon">info</mat-icon>
            <div class="billing-profile-banner__body">
              <div class="billing-profile-banner__title">Complete your billing information</div>
              <div class="billing-profile-banner__subtitle">
                We'll need your country and address before you can start a paid plan or buy seats.
              </div>
            </div>
            <button
              mat-flat-button
              color="primary"
              type="button"
              class="billing-profile-banner__cta"
              (click)="onCompleteBillingInfo()">
              Complete billing info
            </button>
          </div>

          <app-billing-hero
            [state]="billingState()"
            [tierName]="productTierDisplay || planCodeLabel(currentPlanCode)"
            [periodLabel]="subscriptionBillingPeriod"
            [seats]="quota_allowed"
            [activeUsers]="useUser"
            [validUntil]="quota_expired_date"
            [daysLeft]="heroDaysLeft()"
            [recommendedTierName]="''"
            [autoRenew]="subscription_status ? is_auto_renew_status : null"
            [subscriptionStatus]="subscription_status"
            [yearlySaveHint]="yearlySwitchHint()"
            [priceLine]="currentSeatPriceLine()"
            [whatsappUrl]="supportWhatsAppUrl('billing')"
            [checkoutOpen]="seatCheckoutExpanded"
            [nextChargeLine]="nextChargeHeroLine()"
            [actionsReady]="heroPrimaryReady()"
            [actionsPending]="heroPrimaryPending()"
            [showRefresh]="heroShowRefresh()"
            (primary)="onHeroPrimary()"
            (secondary)="onHeroSecondary()"
            (refresh)="refreshBillingData()">
          </app-billing-hero>


        </ng-container>

        <div class="billing-snapshot-loader" *ngIf="loading">
          <ngx-skeleton-loader count="1"
            [theme]="{ 'border-radius': '12px', height: '96px', width: '100%' }"></ngx-skeleton-loader>
        </div>

        <!-- Checkout row -->
        <section id="manage-seats-section" class="seat-checkout-redesign billing-section-card"
          *ngIf="!loading && seatCheckoutExpanded"
          [class.seat-subscription-section--spotlight]="seatSectionAttention">
          <div class="seat-checkout-panel-header">
            <div class="seat-checkout-panel-title-group">
              <div>
                <h3>{{ seatCheckoutPanelTitle }}</h3>
                <p class="seat-checkout-plan-rate" *ngIf="showCheckoutChangePlan()">
                  <ng-container *ngIf="checkoutPlanRateLine() as rate">{{ rate }} · </ng-container>
                  <button type="button" class="change-plan-btn" (click)="openPlanPicker()">Change plan</button>
                </p>
              </div>
            </div>
            <button mat-icon-button type="button" (click)="collapseSeatCheckout()"
              aria-label="Close seat checkout">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="seat-checkout-grid" [class.seat-checkout-grid--compact]="selected_plan_type === 'addon'">
            <div class="seat-checkout-left">
              <!-- Seats stepper -->
              <div class="checkout-block">
                <label class="checkout-block-label" for="usersLimitsInput">Number of seats</label>
                <div class="seat-stepper">
                  <button mat-icon-button type="button" aria-label="Fewer seats"
                    (click)="nudgeSeats(-1)" [disabled]="user <= min">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input matInput type="number" [min]="min" #usersLimitInput id="usersLimitsInput"
                    [(ngModel)]="user" (ngModelChange)="onKey($event)" />
                  <button mat-icon-button type="button" aria-label="More seats"
                    (click)="nudgeSeats(1)">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
                <div class="seat-quick-row" *ngIf="selected_plan_type === 'addon'">
                  <button type="button" class="seat-quick-pick" (click)="nudgeSeats(5)">+5 more</button>
                  <button type="button" class="seat-quick-pick" (click)="nudgeSeats(10)">+10 more</button>
                  <span class="seat-total-chip">{{ addSeatsTotal() }} seats in total</span>
                </div>
                <p class="checkout-helper" *ngIf="renewalSoonHint()">{{ renewalSoonHint() }}</p>
                <p class="checkout-helper" *ngIf="selected_plan_type === 'main' || isAdvancePayment || checkoutMode === 'setup' || checkoutMode === 'renew'">
                  Minimum {{ min }} seat{{ min !== 1 ? 's' : '' }}<ng-container *ngIf="activeEmployeeCount > 0"> (you have {{ activeEmployeeCount }} {{ activeEmployeeCount === 1 ? 'person' : 'people' }} on the account)</ng-container>.<ng-container *ngIf="activeEmployeeCount > 0"> To pay for fewer, remove people first.</ng-container>
                </p>
                <p class="checkout-helper checkout-helper--band" *ngIf="bandHintLine()">{{ bandHintLine() }}</p>
                <mat-hint *ngIf="isHint" class="mat-hint">Minimum {{ min }} seat{{ min !== 1 ? 's' : '' }} required</mat-hint>
              </div>

              <!-- Period cards -->
              <div class="checkout-block" *ngIf="selected_plan_type !== 'addon'">
                <div class="checkout-block-label" id="billing-period-label">Billing period</div>
                <div class="period-cards period-cards--loading" *ngIf="seatPricesLoading" aria-hidden="true">
                  <ngx-skeleton-loader *ngFor="let sk of priceSkeletonSlots" count="1"
                    [theme]="{ 'border-radius': '12px', height: '148px', width: '100%', margin: '0' }"></ngx-skeleton-loader>
                </div>
                <div class="period-cards" role="radiogroup" aria-labelledby="billing-period-label" *ngIf="!seatPricesLoading">
                  <button type="button" class="period-card"
                    *ngFor="let opt of availablePeriodOptions()"
                    role="radio"
                    [attr.aria-checked]="isPeriodSelected(opt.period)"
                    [attr.aria-disabled]="!opt.available || !canChangeSeatBillingCadence()"
                    [disabled]="!opt.available || !canChangeSeatBillingCadence()"
                    [class.period-card--selected]="isPeriodSelected(opt.period)"
                    [class.period-card--disabled]="!opt.available || !canChangeSeatBillingCadence()"
                    (click)="selectPeriodOption(opt.period)">
                    <span class="period-card-badge" *ngIf="opt.badge === 'best_value'">Best value</span>
                    <mat-icon class="period-card-check" *ngIf="isPeriodSelected(opt.period)">check_circle</mat-icon>
                    <span class="period-card-name">{{ periodCardTitle(opt.period) }}</span>
                    <span class="period-card-price" *ngIf="opt.available">
                      <ng-container *ngIf="billing_country === 'IN'">₹{{ opt.perSeatMonthly }}</ng-container>
                      <ng-container *ngIf="billing_country !== 'IN'">${{ opt.perSeatMonthly }}</ng-container>
                      <small>/seat/month</small>
                    </span>
                    <span class="period-card-term" *ngIf="opt.available">
                      <ng-container *ngIf="billing_country === 'IN'">₹{{ opt.perSeatTerm }}</ng-container>
                      <ng-container *ngIf="billing_country !== 'IN'">${{ opt.perSeatTerm }}</ng-container>
                      per seat every {{ periodTermText(opt.period) }}
                    </span>
                    <span class="period-card-save" *ngIf="opt.available && opt.savingsVsMonthlyPerYear > 0">
                      Save
                      <ng-container *ngIf="billing_country === 'IN'">₹{{ opt.savingsVsMonthlyPerYear }}</ng-container><ng-container *ngIf="billing_country !== 'IN'">${{ opt.savingsVsMonthlyPerYear }}</ng-container>/year ({{ opt.savingsPercent }}%)
                    </span>
                  </button>
                </div>
                <p class="cadence-lock-message" *ngIf="cadenceLockMessage()">{{ cadenceLockMessage() }}</p>
              </div>

              <!-- Auto-renew / GST -->
              <div class="checkout-block checkout-options"
                [class.checkout-options--compact]="selected_plan_type === 'addon'">
                <div class="txt_gst" *ngIf="billing_country === 'IN' && selected_plan_type === 'addon'">
                  <button type="button" class="billing-link-btn" (click)="isGST = !isGST">
                    {{ isGST ? 'Remove GSTIN' : '+ Add GSTIN' }}
                  </button>
                </div>
                <div class="txt_gst" *ngIf="billing_country === 'IN' && selected_plan_type !== 'addon'">
                  <mat-checkbox class="example-margin" [(ngModel)]="isGST">
                    Add GSTIN for a tax invoice
                  </mat-checkbox>
                </div>
                <div class="txt_gst" *ngIf="isGST && billing_country === 'IN'">
                  <mat-form-field class="mat-form" appearance="outline">
                    <mat-label>GSTIN</mat-label>
                    <input matInput type="text" [(ngModel)]="txtGst"
                      placeholder="15-character GSTIN"
                      (blur)="varifyAction()" />
                  </mat-form-field>
                  <p class="checkout-helper" *ngIf="isGST && txtGst && !isGSTVerified">
                    Enter a valid 15-character GSTIN.
                  </p>
                </div>
                <div class="seat-auto-renew-row" *ngIf="selected_plan_type !== 'addon'">
                  <div>
                    <div class="seat-auto-renew-title">Auto-renew</div>
                    <div class="seat-auto-renew-copy" *ngIf="auto_renew">
                      We'll charge your total {{ autoRenewEveryPhrase() }} on your saved method. Turn off anytime.
                    </div>
                    <div class="seat-auto-renew-copy" *ngIf="!auto_renew">
                      Enable to renew automatically on your saved method {{ autoRenewEveryPhrase() }}.
                    </div>
                  </div>
                  <mat-slide-toggle [(ngModel)]="auto_renew" color="primary"></mat-slide-toggle>
                </div>
              </div>
            </div>

            <!-- Order summary -->
            <aside class="seat-checkout-summary" aria-live="polite">
              <h4 class="summary-title">Order summary</h4>
              <div class="summary-outcome summary-outcome--success" *ngIf="paymentOutcome === 'success'">
                <mat-icon>check_circle</mat-icon>
                <div>
                  <p>{{ paymentOutcomeMessage }}</p>
                  <a class="billing-profile-link" (click)="moveToBillingInvoices()">View invoice</a>
                </div>
              </div>
              <div class="summary-outcome summary-outcome--failed" *ngIf="paymentOutcome === 'failed'">
                <mat-icon>error_outline</mat-icon>
                <div>
                  <p>{{ paymentOutcomeMessage }}</p>
                  <button mat-button type="button" color="primary" (click)="clearPaymentOutcome()">Try again</button>
                </div>
              </div>
              <div *ngIf="(isLoadingPrice || seatPricesLoading) && paymentOutcome === 'idle'" class="summary-loading">
                <ngx-skeleton-loader count="4"
                  [theme]="{ 'border-radius': '4px', height: '18px', width: '100%', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
              </div>
              <ng-container *ngIf="!isLoadingPrice && !seatPricesLoading && paymentOutcome !== 'success'">
                <ng-container *ngIf="selected_plan_type !== 'addon'">
                <p class="summary-changes" *ngIf="checkoutChangesLine()">{{ checkoutChangesLine() }}</p>
                <div class="summary-line" *ngIf="!summaryBreakdown.length">
                  <span>{{ user }} seat{{ +user === 1 ? '' : 's' }} ×
                    <ng-container *ngIf="billing_country === 'IN'">₹{{ selected_price }}</ng-container>
                    <ng-container *ngIf="billing_country !== 'IN'">${{ selected_usd_price }}</ng-container>
                  </span>
                  <span>
                    <ng-container *ngIf="billing_country === 'IN'">₹{{ totalUser }}</ng-container>
                    <ng-container *ngIf="billing_country !== 'IN'">${{ totalUser_usd }}</ng-container>
                  </span>
                </div>
                <ng-container *ngIf="summaryBreakdown.length">
                  <p class="summary-section-label">How this total is built</p>
                  <div class="summary-line summary-line--muted" *ngFor="let row of summaryBreakdown">
                    <span>
                      {{ row.label }}
                      <small class="summary-hint" *ngIf="row.hint">{{ row.hint }}</small>
                    </span>
                    <span *ngIf="row.amount">{{ row.amount }}</span>
                  </div>
                  <div class="summary-line">
                    <span>Subtotal
                      <small class="summary-hint">{{ user }} seats · list rate
                        <ng-container *ngIf="billing_country === 'IN'">₹{{ selected_price }}</ng-container>
                        <ng-container *ngIf="billing_country !== 'IN'">${{ selected_usd_price }}</ng-container>
                        / seat
                      </small>
                    </span>
                    <span>
                      <ng-container *ngIf="billing_country === 'IN'">₹{{ totalUser }}</ng-container>
                      <ng-container *ngIf="billing_country !== 'IN'">${{ totalUser_usd }}</ng-container>
                    </span>
                  </div>
                </ng-container>
                <div class="summary-line summary-line--muted" *ngIf="!summaryBreakdown.length && strCaption">
                  <span>{{ strCaption }} {{ strDateCption }}</span>
                </div>
                <div class="summary-line summary-line--muted" *ngIf="!summaryBreakdown.length && strSubCaption">
                  <span>{{ strSubCaption }} {{ strSubDateCaption }}</span>
                </div>
                <div class="summary-line" *ngIf="billing_country === 'IN'">
                  <span *ngIf="billing_state === 'GJ'">GST 18% (CGST + SGST)</span>
                  <span *ngIf="billing_state && billing_state !== 'GJ'">GST 18% (IGST)</span>
                  <span *ngIf="!billing_state">GST 18%</span>
                  <span>₹{{ gstPrice }}</span>
                </div>
                <div class="summary-total">
                  <span>Total today</span>
                  <strong *ngIf="!quoteErrorMessage && ((billing_country === 'IN' ? +totalInr : +totalUsd) > 0)">
                    <ng-container *ngIf="billing_country === 'IN'">₹{{ totalInr }}</ng-container>
                    <ng-container *ngIf="billing_country !== 'IN'">${{ totalUsd }}</ng-container>
                  </strong>
                  <strong *ngIf="quoteErrorMessage || ((billing_country === 'IN' ? +totalInr : +totalUsd) <= 0)">—</strong>
                </div>
                <p class="summary-next" *ngIf="checkoutCoverageLine()">{{ checkoutCoverageLine() }}</p>
                <p class="summary-next" *ngIf="renewalTermLine()">{{ renewalTermLine() }}</p>
                </ng-container>
                <ng-container *ngIf="selected_plan_type === 'addon'">
                  <div class="summary-section-label">Pay today</div>
                  <div class="summary-line">
                    <span>{{ strCaption || (user + ' seat' + (+user === 1 ? '' : 's')) }}</span>
                    <span>{{ money(billing_country === 'IN' ? totalUser : totalUser_usd) }}</span>
                  </div>
                  <div class="summary-line" *ngIf="billing_country === 'IN'">
                    <span *ngIf="billing_state === 'GJ'">GST 18% (CGST + SGST)</span>
                    <span *ngIf="billing_state && billing_state !== 'GJ'">GST 18% (IGST)</span>
                    <span *ngIf="!billing_state">GST 18%</span>
                    <span>{{ money(gstPrice) }}</span>
                  </div>
                  <div class="summary-total">
                    <span>Total</span>
                    <strong>{{ money(billing_country === 'IN' ? totalInr : totalUsd) }}</strong>
                  </div>
                  <div class="summary-renewal" *ngIf="addonRenewalLine() as renewal">
                    <div class="summary-section-label">From {{ formattedDate(expire_date) }}, your renewal</div>
                    <p>{{ renewal }}</p>
                  </div>
                </ng-container>
                <p class="summary-error" *ngIf="quoteErrorMessage">
                  {{ quoteErrorMessage }}
                  <button mat-button type="button" color="primary"
                    *ngIf="quoteSeatsShortfall"
                    (click)="addSeatsToCoverQuoteShortfall()">
                    Add {{ quoteSeatsShortfall }} seat{{ quoteSeatsShortfall === 1 ? '' : 's' }}
                  </button>
                  <button mat-button type="button" color="primary" *ngIf="!quoteSeatsShortfall"
                    (click)="retryBillingQuote()">Try again</button>
                </p>
                <p class="summary-blocked" *ngIf="!billing_country">
                  Add your billing details to continue.
                  <a class="billing-profile-link" (click)="openBillingDialog()">Update billing profile</a>
                </p>
                <button class="buy_now billing-primary-pay" type="button" (click)="initiateUpgrade()"
                  [disabled]="!billing_country || (totalUser == 0 && totalUser_usd == 0) || loading || checkGST()">
                  {{ checkoutCtaLabel() }}
                </button>
                <ul class="summary-reassure">
                  <li><mat-icon>lock</mat-icon><span>Secure payment by Razorpay</span></li>
                  <li *ngIf="selected_plan_type !== 'addon'">
                    <mat-icon>receipt</mat-icon>
                    <span>{{ billing_country === 'IN' ? 'GST invoice by email' : 'Invoice by email' }}</span>
                  </li>
                  <li *ngIf="selected_plan_type !== 'addon' && auto_renew">
                    <mat-icon>event</mat-icon><span>Turn off auto-renew anytime</span>
                  </li>
                </ul>
              </ng-container>
            </aside>
          </div>
        </section>

        <!-- Mobile sticky pay bar -->
        <div class="billing-mobile-paybar" *ngIf="!loading && seatCheckoutExpanded && !isLoadingPrice">
          <button type="button" class="billing-mobile-paybar-total" (click)="mobileSummaryExpanded = !mobileSummaryExpanded">
            Total
            <strong *ngIf="billing_country === 'IN'">₹{{ totalInr }}</strong>
            <strong *ngIf="billing_country !== 'IN'">${{ totalUsd }}</strong>
          </button>
          <button class="buy_now billing-primary-pay" type="button" (click)="initiateUpgrade()"
            [disabled]="!billing_country || (totalUser == 0 && totalUser_usd == 0) || loading || checkGST()">
            {{ checkoutCtaLabel() }}
          </button>
        </div>

        <div class="billing-page-main" *ngIf="loading">
          <section class="product-tier-section billing-section-card">
            <div class="product-tier-cards-row" style="margin-top: 16px;">
              <article class="product-tier-card" *ngFor="let sk of priceSkeletonSlots">
                <ngx-skeleton-loader count="1"
                  [theme]="{ 'border-radius': '4px', height: '280px', width: '100%' }"></ngx-skeleton-loader>
              </article>
            </div>
          </section>
        </div>

        <ng-container *ngIf="!loading">
          <section class="billing-upgrade billing-section-card" *ngIf="upgradeOffer() as offer"
            aria-labelledby="billing-upgrade-heading">
            <div class="billing-upgrade-copy">
              <span class="billing-upgrade-eyebrow">Next plan</span>
              <h4 id="billing-upgrade-heading">What {{ offer.tier.name }} adds</h4>
              <ul class="billing-upgrade-gains" *ngIf="offer.gains.length">
                <li *ngFor="let gain of offer.gains"><mat-icon aria-hidden="true">check</mat-icon>{{ gain }}</li>
              </ul>
              <div class="billing-upgrade-limits" *ngIf="nearPlanLimits().length">
                <div class="billing-upgrade-limit" *ngFor="let meter of nearPlanLimits()">
                  <div class="billing-upgrade-limit-label">
                    <span>{{ meter.label }}</span>
                    <span>{{ meter.used }}{{ meter.unit }} of {{ meter.max }}{{ meter.unit }}</span>
                  </div>
                  <div class="billing-upgrade-limit-track" role="progressbar" [attr.aria-label]="meter.label"
                    [attr.aria-valuenow]="meter.used" aria-valuemin="0" [attr.aria-valuemax]="meter.max">
                    <div class="billing-upgrade-limit-fill" [style.width.%]="meterPercent(meter)"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="billing-upgrade-action">
              <ng-container *ngIf="tierPriceDelta(offer.tier) as delta">
                <span class="billing-upgrade-delta">{{ delta.perSeat }}</span>
                <span class="billing-upgrade-delta-note">{{ delta.total }}</span>
              </ng-container>
              <button mat-flat-button color="primary" type="button" class="product-tier-cta billing-upgrade-cta"
                [disabled]="isTierCtaDisabled(offer.tier)" (click)="onTierCta(offer.tier)">
                <mat-spinner *ngIf="isTierCtaLoading(offer.tier)" diameter="20"></mat-spinner>
                <span *ngIf="!isTierCtaLoading(offer.tier)">{{ tierCtaLabel(offer.tier) }}</span>
              </button>
              <span class="billing-upgrade-delta-note">You see the exact amount before you pay.</span>
            </div>
          </section>

          <!-- While a checkout is open, a collapsed comparison is just an empty card; "Change plan" opens it. -->
          <section class="product-tier-section billing-section-card"
            *ngIf="isCompareOpen() || !seatCheckoutExpanded"
            [class.product-tier-section--collapsed]="!isCompareOpen()" aria-labelledby="product-tier-heading">
            <div class="product-tier-section-header">
              <div>
                <h4 id="product-tier-heading" class="product-tier-section-title">
                  {{ billingPageMode() === 'trial' ? 'Choose your plan' : 'Compare plans' }}
                </h4>
                <p class="product-tier-section-lead">
                  <ng-container *ngIf="billingPageMode() === 'top' && !isCompareOpen()">You're on our top plan. </ng-container>
                  <ng-container *ngIf="billingState() !== 'expired' && billingState() !== 'trial'">
                    Your {{ quota_allowed || totalUserCurrent }} paid seats stay the same when you change plan.
                  </ng-container>
                </p>
              </div>
              <button type="button" class="plan-compare-toggle" *ngIf="billingPageMode() !== 'trial'"
                [attr.aria-expanded]="isCompareOpen()" aria-controls="plan-compare-body" (click)="toggleCompare()">
                {{ isCompareOpen() ? 'Hide comparison' : 'Compare all plans' }}
                <mat-icon aria-hidden="true">{{ isCompareOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </div>
            <div id="plan-compare-body" *ngIf="isCompareOpen()">

            <ngx-skeleton-loader *ngIf="planCatalogLoading || seatPricesLoading" count="1"
              [theme]="{ 'border-radius': '12px', height: '420px', width: '100%' }"></ngx-skeleton-loader>

            <ng-container *ngIf="!planCatalogLoading && !seatPricesLoading">
            <div class="plan-compare-period" role="radiogroup" aria-label="Billing period for comparison">
              <button type="button" class="plan-compare-period-btn" *ngFor="let opt of comparePeriodChoices"
                role="radio"
                [attr.aria-checked]="comparePeriodSlug() === opt.period"
                [class.plan-compare-period-btn--active]="comparePeriodSlug() === opt.period"
                (click)="selectComparePeriod(opt.period)">{{ opt.label }}</button>
            </div>

            <div class="plan-compare-tabs" role="tablist" aria-label="Plan to compare with yours"
              *ngIf="compareTabTiers().length > 1">
              <button type="button" role="tab" class="plan-compare-tab" *ngFor="let tier of compareTabTiers()"
                [attr.aria-selected]="tier.plan_code === mobileCompareCode()"
                [class.plan-compare-tab--active]="tier.plan_code === mobileCompareCode()"
                (click)="compareMobileTier = tier.plan_code">{{ tier.name }}</button>
            </div>

            <div class="plan-compare-scroll" *ngIf="planTiers.length">
              <table class="plan-compare">
                <thead>
                  <tr>
                    <th scope="col" class="plan-compare-corner"><span class="cdk-visually-hidden">Feature</span></th>
                    <th scope="col" class="plan-compare-head" *ngFor="let tier of planTiers"
                      [id]="'tier-card-' + tier.plan_code"
                      [class.plan-compare-col--current]="isCurrentPlanTier(tier)"
                      [class.plan-compare-col--mobile-hidden]="isCompareColumnHiddenOnMobile(tier)"
                      [class.plan-compare-col--highlight]="isTierHighlighted(tier)">
                      <span class="plan-compare-badge" *ngIf="isCurrentPlanTier(tier)">Your plan</span>
                      <span class="plan-compare-badge plan-compare-badge--recommended"
                        *ngIf="showRecommendedBadge(tier)">Recommended</span>
                      <span class="plan-compare-badge" *ngIf="isCheckoutTierSelected(tier)">Selected</span>
                      <span class="plan-compare-name">{{ tier.name }}</span>
                      <span class="plan-compare-price" *ngIf="tierPriceParts(tier) as price">
                        <strong>{{ price.amount }}</strong> /seat/month
                        <small>{{ price.note }}</small>
                      </span>
                      <span class="plan-compare-tagline">{{ tier.tagline }}</span>
                      <button mat-flat-button color="primary" type="button" class="product-tier-cta"
                        *ngIf="!isCurrentPlanTier(tier)"
                        [class.product-tier-cta--downgrade]="isDowngradeTier(tier)"
                        [disabled]="isTierCtaDisabled(tier)" (click)="onTierCta(tier)">
                        <mat-spinner *ngIf="isTierCtaLoading(tier)" diameter="20"></mat-spinner>
                        <span *ngIf="!isTierCtaLoading(tier)">{{ tierCtaLabel(tier) }}</span>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody *ngFor="let group of compareGroups">
                  <tr class="plan-compare-group">
                    <th scope="rowgroup" [attr.colspan]="planTiers.length + 1">{{ group.title }}</th>
                  </tr>
                  <tr *ngFor="let row of group.rows">
                    <th scope="row" class="plan-compare-label">{{ row.label }}</th>
                    <td *ngFor="let tier of planTiers"
                      [class.plan-compare-col--current]="isCurrentPlanTier(tier)"
                      [class.plan-compare-col--mobile-hidden]="isCompareColumnHiddenOnMobile(tier)">
                      <ng-container [ngSwitch]="compareCell(row, tier)">
                        <span *ngSwitchCase="true" class="plan-compare-yes">
                          <mat-icon aria-hidden="true">check</mat-icon><span class="cdk-visually-hidden">Included</span>
                        </span>
                        <span *ngSwitchCase="false" class="plan-compare-no">
                          <span aria-hidden="true">—</span><span class="cdk-visually-hidden">Not included</span>
                        </span>
                        <span *ngSwitchCase="null"></span>
                        <span *ngSwitchDefault class="plan-compare-text">{{ compareCell(row, tier) }}</span>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="plan-compare-footnote" *ngIf="planTiers.length">{{ compareFootnote }}</p>
            </ng-container>
            </div>
          </section>
        </ng-container>
        </div>

        <aside class="billing-layout-rail" *ngIf="!loading" aria-label="Account">
          <section class="billing-addons-section billing-section-card"
            aria-labelledby="billing-addons-heading">
            <div class="billing-addons-header">
              <div>
                <h4 id="billing-addons-heading" class="billing-addons-title">Add-ons</h4>
                <p class="billing-addons-lead">
                  Current add-on assignment and configuration for this company.
                </p>
              </div>
            </div>
            <ngx-skeleton-loader *ngIf="addOnsLoading" count="2"
              [theme]="{ 'border-radius': '8px', height: '72px', width: '100%', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
            <div class="billing-addons-error" *ngIf="!addOnsLoading && addOnStateMessage">{{ addOnStateMessage }}</div>
            <p class="billing-addons-empty"
              *ngIf="!addOnsLoading && !addOnStateMessage && !addOnsForBillingView().length">
              No add-ons assigned. Plan features are included in your tier; purchased add-ons will show here.
            </p>
            <div class="billing-addons-grid" *ngIf="!addOnsLoading && !addOnStateMessage && addOnsForBillingView().length">
              <article class="billing-addon-card" *ngFor="let addon of addOnsForBillingView()">
                <div class="billing-addon-card-header">
                  <div>
                    <h5>{{ addon.label }}</h5>
                    <p>{{ addOnAssignmentLabel(addon) }}</p>
                  </div>
                  <span class="billing-addon-status"
                    [class.billing-addon-status--disabled]="!addon.enabled">
                    {{ addon.enabled ? 'Enabled' : 'Disabled' }}
                  </span>
                </div>
                <p class="billing-addon-description" *ngIf="addon.description">{{ addon.description }}</p>
                <div class="billing-addon-meta">
                  <span *ngIf="addOnConfigLabel(addon) as configLabel">{{ configLabel }}</span>
                  <span *ngIf="addon.status && addon.status !== 'active'">{{ addon.status | titlecase }}</span>
                </div>
                <p class="billing-addon-users" *ngIf="addon.assignment_mode === 'specific_users'">
                  <strong>Employees:</strong> {{ addOnSpecificUserNames(addon) }}
                </p>
              </article>
            </div>
          </section>

          <section class="billing-section-card billing-rail-card">
            <div class="billing-records-col" aria-labelledby="recent-invoices-heading">
              <div class="billing-records-head">
                <h4 id="recent-invoices-heading">Recent invoices</h4>
                <button type="button" class="billing-link-btn" (click)="moveToBillingInvoices()">View all</button>
              </div>
              <ngx-skeleton-loader *ngIf="recentInvoicesLoading" count="3"
                [theme]="{ 'border-radius': '6px', height: '20px', width: '100%', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
              <p class="billing-records-empty" *ngIf="!recentInvoicesLoading && recentInvoicesError">
                {{ recentInvoicesError }}
                <button type="button" class="billing-link-btn" (click)="loadRecentInvoices()">Try again</button>
              </p>
              <p class="billing-records-empty"
                *ngIf="!recentInvoicesLoading && !recentInvoicesError && !recentInvoices.length">No invoices yet.</p>
              <ul class="billing-invoice-list" *ngIf="!recentInvoicesLoading && recentInvoices.length">
                <li *ngFor="let invoice of recentInvoices">
                  <span class="billing-invoice-date">{{ invoice.invoice_date | date: 'mediumDate' }}</span>
                  <span class="billing-invoice-no">{{ invoice.invoice_no }}</span>
                  <span class="billing-invoice-amount">{{ invoiceAmountText(invoice) }}</span>
                  <span class="billing-invoice-status">{{ invoiceStatusText(invoice.status) }}</span>
                </li>
              </ul>
            </div>
          </section>

          <section class="billing-section-card billing-rail-card">
            <div class="billing-records-col" aria-labelledby="billing-details-heading">
              <div class="billing-records-head">
                <h4 id="billing-details-heading">Billing details</h4>
                <button type="button" class="billing-link-btn" (click)="openBillingDialog()">Edit</button>
              </div>
              <ngx-skeleton-loader *ngIf="loading" count="2"
                [theme]="{ 'border-radius': '6px', height: '20px', width: '100%', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
              <dl class="billing-details-list" *ngIf="!loading">
                <div>
                  <dt>Billing address</dt>
                  <dd>{{ billingLocationText() }}</dd>
                </div>
                <div *ngIf="billing_country === 'IN'">
                  <dt>GSTIN</dt>
                  <dd>{{ txtGst || 'Not added' }}</dd>
                </div>
              </dl>
            </div>
          </section>

          <section class="billing-manage billing-section-card"
            *ngIf="quotaStatus === 'active'" aria-labelledby="billing-manage-heading">
            <h4 id="billing-manage-heading">Subscription</h4>
            <div class="billing-manage-row">
              <span>Status: <b>{{ displaySubscriptionStatusText }}</b></span>
              <span *ngIf="displaySubscriptionStatusText !== 'Cancelled' && displaySubscriptionStatusText !== 'None'">Auto-renew: <b>{{ displayAutoRenewText }}</b></span>
              <span *ngIf="rzp_next_renewal_date || nextChargeDate">Next renewal:
                <b>{{ (rzp_next_renewal_date || nextChargeDate) | date: 'mediumDate' }}</b>
              </span>
              <span *ngIf="nextChargeAmount != null && pricingMode !== 'custom'">
                Next charge: <b>{{ subscriptionNextChargeText() }}</b>
              </span>
              <button mat-button color="warn" type="button" class="billing-manage-cancel"
                *ngIf="displaySubscriptionStatusText === 'Active' && !!razorpaySubscriptionId"
                (click)="cancelSubscriptionAction()">Cancel subscription</button>
            </div>
            <p class="billing-manage-hint" *ngIf="displaySubscriptionStatusText !== 'Cancelled' && renewal_notification_text">
              {{ renewal_notification_text }}
            </p>
          </section>
        </aside>
        </div>
      </div>
    </mat-card>

    <mat-card class="system-config-card billing-page-card" *ngIf="!isAdmin && !loading">
      <div class="billing-non-admin">
        <h2 class="billing-page-title">Billing</h2>
        <p>Billing is managed by your company admin. Ask them to add seats or change your plan.</p>
      </div>
    </mat-card>

    <div class="billing-page-footer" *ngIf="!loading && isAdmin">
      <p class="billing-page-footer-note">
        <span>Questions about tiers, seats, or invoices?</span>
        <a [href]="'tel:' + supportPhoneHref()">{{ supportPhoneDisplay() }}</a>
        ·
        <a [href]="supportWhatsAppUrl('billing')" target="_blank" rel="noopener"
          (click)="billingAnalytics.track('help_clicked', { channel: 'whatsapp' })">WhatsApp support</a>
      </p>
    </div>
  </div>
</div>
